import { handleActions } from 'redux-actions-helpers';
import { getSportsSuccess, sportsReorder, sportsSelect, sportsVisible, setCountTotalSports } from './actions';
import { reorder } from '../utils';

export const initialState = {
    items          : [],
    selected       : 0,
    total          : 0,
    isVisibleSports: true
};

export default handleActions({
    [getSportsSuccess]: (state, { items }) => {
        return {
            ...state,
            items,
            selected: items.length ? items[0].gameId : initialState.selected
        }
    },
    [sportsReorder]: (state, { startIndex, endIndex }) => {
        return {
            ...state,
            items: reorder(state.items, startIndex, endIndex)
        }
    },
    [sportsSelect]: (state, { id }) => {
        return {
            ...state,
            selected: id
        }
    },
    [setCountTotalSports]: (state, { total }) => {
        return {
            ...state,
            total
        }
    },
    [sportsVisible]: (state, { isVisible }) => {
        return {
            ...state,
            isVisibleSports: isVisible
        }
    }
}, { initialState });



// WEBPACK FOOTER //
// ./src/blocks/sports/reducer.js